export default {
	state: {
		adigeya: [
			{
				id: '0001',
				city: 'Республика Адыгея',
				street: 'ул Новая Адыгея,Тургеневское шоссе 27',
				shop: 'АШАН'
			}
		]
	},
	mutations: {},
	actions: {},


	getters: {
		getAdigeya (state) {
			return state.adigeya
		}
	}
}